import React from 'react';
import { connect } from "react-redux";
import { BrowserRouter, Route, NavLink, withRouter } from 'react-router-dom';
import _ from "lodash";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IosLogOut from 'react-ionicons/lib/IosLogOut';

//actions import
import {logOutUser} from "../actions/AuthenticationActions";
import { fetchAnnouncements, fetchScheduledAnnouncements } from "../actions/AnnouncementsActions";
import { fetchAdmins, fetchClientUsers } from "../actions/AppActions";
import { fetchProfile } from "../actions/ProfileActions";
import { fetchSystemInfo } from "../actions/AppActions";
import { fetchServices, fetchLegalServices } from "../actions/ServicesActions";

//components import
import Home from "./home/Home";
import Announcement from "./announcements/Announcement";
import Services from "./services/Services";
import Service from "./services/Service";
import SignUpPage from './authentication/SignUpPage';
import Profiles from './authentication/Profiles';
import Settings from "./settings/Settings";
import ManageUser from "./authentication/ManageUser";
import Download from "./download/Download";

//file imports
import Logo from '../assets/logo/logo.png';
import {BeatLoader} from "react-spinners";


class Main extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            systemInfo: this.props.systemInfo,
            user: null,
            profile: this.props.profile,
            navTitle: 'hideTitle'
        };

        this.hoverActivated = this.hoverActivated.bind(this);
        this.hoverDeactivated = this.hoverDeactivated.bind(this);
        this.onLogOutPress = this.onLogOutPress.bind(this);

    }

    componentWillMount() {
        this.props.fetchAdmins();
        this.props.fetchActivities({ startAt: 20 });
        this.props.fetchClientUsers();
        this.props.fetchProfile();
        this.props.fetchSystemInfo();
        this.props.fetchLegalServices();
        this.props.fetchAnnouncements({ startAt: 20 });
        this.props.fetchScheduledAnnouncements({ startAt: 20 });
    }

    componentWillReceiveProps(nextProps, nextContext) {

        if (nextProps.systemInfo !== this.props.systemInfo) {
            this.setState({ systemInfo: nextProps.systemInfo })
        }

        if (nextProps.profile !== this.props.profile) {
            this.setState({ profile: nextProps.profile })
        }
    }

    onLogOutPress() {
        //
        const {history} = this.props;

        localStorage.removeItem("lalertPrimeInitializationObject");
        localStorage.removeItem("lalertInitializedProject");
        //log out action called
        this.props.logOutUser(history);
    }

    renderProfile() {
        //extract state
        const { profile } = this.state;

        //check if profile is not empty
        if (!(_.isEmpty(profile))) {
            switch (profile.role) {
                case "admin":
                    return <h4><b>{profile.name}</b> | Administrator</h4>;
                case "advocate":
                    return <h4><b>{profile.name}</b> | Advocate</h4>;
                case "accountant":
                    return <h4><b>{profile.name}</b> | Accountant</h4>;
                case "superAdmin":
                    return <h4><b>{profile.name}</b> | Super Admin</h4>;
                default:
                    return <h4>Admin</h4>;
            }
        } else {
            return <BeatLoader/>
        }
    }

    hoverActivated() {
        this.setState({ navTitle: 'showTitle'});
    }

    hoverDeactivated() {
        this.setState({ navTitle: 'hideTitle'});
    }

    renderSystem() {
        //extract state
        const { profile, systemInfo } = this.state;

        //check if profile is not empty
        if (!(_.isEmpty(profile))) {
            if (!(_.isEmpty(systemInfo))) {
                return(
                    <div className={"bodyContainerContents"}>
                        <Route exact path={"/"} component={Home} />
                        <Route exact path={"/announcement"} component={Announcement} />
                        <Route exact path={"/services"} component={Services} />
                        <Route exact path={"/service"} component={Service} />
                        <Route exact path={"/profiles"} component={Profiles} />
                        <Route exact path={"/sign-up"} component={SignUpPage} />
                        <Route exact path={"/manage-user"} component={ManageUser} />
                        <Route exact path={"/settings"} component={Settings} />
                        <Route exact path={"/download"} component={Download} />
                    </div>
                );
            } else {
                return <BeatLoader/>;
            }
        } else { 
            return <BeatLoader/>
        }
    }

    render() {

        const { navTitle } = this.state;

        return (
            <BrowserRouter>
                <div className={"mainContainer"}>
                    <div className={"nav"} onMouseEnter={() => this.hoverActivated()} onMouseLeave={() => this.hoverDeactivated()}>
                        <div className={"logoBox"}>
                            <img src={Logo} alt="tata logo" height={60} width={60} />
                        </div>
                        <ul>
                            <li><NavLink to={'/'}><FontAwesomeIcon icon="object-group" /><span id={navTitle}> Home</span></NavLink></li>
                            <li><NavLink to={'/services'}><FontAwesomeIcon icon="chart-line" /><span id={navTitle}> Enquiries</span></NavLink></li>
                            <li><NavLink to={'/profiles'}><FontAwesomeIcon icon="user-alt" /><span id={navTitle}> Profiles</span></NavLink></li>
                            <li><NavLink to={'/settings'}><FontAwesomeIcon icon="sliders-h" /><span id={navTitle}> Settings</span></NavLink></li>
                        </ul>
                    </div>

                    <div className={"bodyContainer"}>
                        <div className={"bodyContainerTopBar"}>
                            <div className={"creditManagerBox"}>
                                { this.renderProfile() }
                                <div className={'iconContainer'}>
                                    <FontAwesomeIcon icon="check-circle" size="lg" color="green" />
                                </div>
                            </div>
                            <div className={"signOutButton"}>  
                                <button onClick={() => this.onLogOutPress()}>
                                    <IosLogOut fontSize="2rem" color="#d40000" />
                                </button>  
                            </div>
                        </div>
                        { this.renderSystem() }
                    </div>
                </div>
            </BrowserRouter>
        );
    }
}

const mapStateToProps = (state) => {

    const { systemInfo } = state.app;
    const { profile } = state.profile;

    return {
        systemInfo,
        profile
    }
};

export default withRouter(connect(mapStateToProps,{ logOutUser, fetchAdmins, fetchProfile, fetchSystemInfo, fetchActivities: fetchServices,
    fetchClientUsers, fetchAnnouncements, fetchScheduledAnnouncements, fetchLegalServices })(Main));
